import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the ViewordinePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare let sunmiInnerPrinter: any;

@IonicPage()
@Component({
  selector: 'page-viewordinericerca',
  templateUrl: 'viewordinericerca.html',
})
export class ViewordinericercaPage {
  public ordineItem;
  info: any;
  ordineItems: any;
  ordineMenu:any;
  valutazione;
  errorMessage: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public rest: RestApiProvider,
  ) {
   // sunmiInnerPrinter.printerInit();
    this.ordineItem = navParams.get('ordine');
    this.getInfoRistorante();
    this.getOrdineItemList();
    this.getOrdineMenu();
    this.getValutazione();
  }
  getValutazione() {
    this.rest.getValutazione(this.ordineItem.id).subscribe(
      valutazione =>{
       // alert(valutazione);
        if(valutazione!=null&&valutazione!=undefined&& valutazione.id>0){
          this.valutazione=valutazione;

        
        }
     },
      error => this.errorMessage = <any>error);
  }
  getInfoRistorante() {
    this.rest.getInfoRistorante()
      .subscribe(
        info => this.info = info,
        error => this.errorMessage = <any>error);

    console.log("infoRistorante:" + JSON.stringify(this.info));
  }
  getOrdineItemList() {
    //  console.log("getOrdineItemList.......................................:"+JSON.stringify(this.ordineItem));
    this.rest.getOrdineItemList(this.ordineItem.id)
      .subscribe(
        ordineItems => this.ordineItems = ordineItems,
        error => this.errorMessage = <any>error);

    console.log("infoRistorante:" + JSON.stringify(this.info));
  }
  getOrdineMenu() {
    this.rest.getOrdineMenu(this.ordineItem.id).subscribe(
      ordineMenu => this.ordineMenu = ordineMenu,
      error => this.errorMessage = <any>error);
  }
  async ordineItemStampa() {

      await sunmiInnerPrinter.printerInit();
      await sunmiInnerPrinter.printOriginalText(" \n");
      await sunmiInnerPrinter.setAlignment(1);// align center
      await sunmiInnerPrinter.printTextWithFont(this.info.nameStore + '\n', 'gh', 35)
  
      await sunmiInnerPrinter.printTextWithFont("Tel." + this.info.fixNumber + '\n', 'gh', 30)
  
      await sunmiInnerPrinter.printOriginalText(" \n");
  
  
  
      await sunmiInnerPrinter.setAlignment(0);// align left
  
      await sunmiInnerPrinter.setFontSize(30);
      //await sunmiInnerPrinter.printTextWithFont("Codice ordine:" + this.ordineItem.id, 'gh', 30)
  
      await sunmiInnerPrinter.setFontSize(30)
      var colsWidthArr = [15, 10];
  
      var colsTextArr = ["Codice ordine", this.ordineItem.id];
      var colsAlign = [0, 2];
  
      await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
  
      await sunmiInnerPrinter.printOriginalText("\n");
  
      if (this.ordineItem.address != null) {
        // await sunmiInnerPrinter.printTextWithFont("Consegna ore:" + this.ordineItem.orario, 'gh', 30)
        await sunmiInnerPrinter.setFontSize(30)
        var colsWidthArr = [15, 10];
        this.ordineItem.orario = this.ordineItem.orario.substring(0, this.ordineItem.orario.length - 3);
        var colsTextArr = ["Ore consegna", this.ordineItem.orario];
        var colsAlign = [0, 2];
  
        await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
  
      } else {
        // await sunmiInnerPrinter.printTextWithFont("Ritiro ore:" + this.ordineItem.orario, 'gh', 30)
        await sunmiInnerPrinter.setFontSize(30)
        var colsWidthArr = [15, 10];
        this.ordineItem.orario = this.ordineItem.orario.substring(0, this.ordineItem.orario.length - 3);
        var colsTextArr = ["Ore ritiro", this.ordineItem.orario];
        var colsAlign = [0, 2];
  
        await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
  
  
      }
  
      await sunmiInnerPrinter.printOriginalText("\n");
  
      await sunmiInnerPrinter.printTextWithFont('-------------------------', 'gh', 30)
  
      await sunmiInnerPrinter.printOriginalText("\n");
  
  
      //stampa menu
      var j;
  
      for (j = 0; j < this.ordineMenu.length; j++) {
        if (this.ordineMenu[j].codice != null && this.ordineMenu[j].codice != "")
          await sunmiInnerPrinter.printTextWithFont("#" + this.ordineMenu[j].quantita + " x " + this.ordineMenu[j].codice + " " + this.ordineMenu[j].nome + '\n', 'gh', 23)
        else
          await sunmiInnerPrinter.printTextWithFont("#" + this.ordineMenu[j].quantita + " x " + this.ordineMenu[j].nome + '\n', 'gh', 26)
  
        var z;
        for (z = 0; z < this.ordineMenu[j].omil.length; z++) {
          await sunmiInnerPrinter.printTextWithFont("  >" + this.ordineMenu[j].omil[z].scelta.nome + '\n', 'gh', 26)
  
  
        }
  
  
      }
  
      //stampa articoli
      var i;
  
      for (i = 0; i < this.ordineItems.length; i++) {
        if (this.ordineItems[i].articolo.codice != null && this.ordineItems[i].articolo.codicee != "")
  
          await sunmiInnerPrinter.printTextWithFont("#" + this.ordineItems[i].quantita + " x " + this.ordineItems[i].articolo.codice + " " + this.ordineItems[i].articolo.name + '\n', 'gh', 26)
        else
          await sunmiInnerPrinter.printTextWithFont("#" + this.ordineItems[i].quantita + " x " + this.ordineItems[i].articolo.name + '\n', 'gh', 26)
  
  
      }
      await sunmiInnerPrinter.printTextWithFont('-------------------------\n', 'gh', 30)
  
  
      await sunmiInnerPrinter.setAlignment(2);// align right
  
      if (this.ordineItem.address != null) {
        // await sunmiInnerPrinter.printTextWithFont('Costo consegna ', 'gh', 25)
        // await sunmiInnerPrinter.printTextWithFont('€. ' + this.ordineItem.consegna.toFixed(2) + '\n', 'gh', 26)
  
        await sunmiInnerPrinter.setFontSize(25)
        var colsWidthArr = [15, 17];
        var colsTextArr: any[];
        colsTextArr = ['Costo consegna', '€. ' + this.ordineItem.consegna.toFixed(2)];
        var colsAlign = [0, 2];
  
        await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
  
      }
  
      // await sunmiInnerPrinter.printTextWithFont('Totale ', 'gh', 30)
      //await sunmiInnerPrinter.printTextWithFont('€. ' + this.ordineItem.totale.toFixed(2) + '\n', 'gh', 30)
  
      await sunmiInnerPrinter.setFontSize(30)
      var colsWidthArr = [10, 16];
      var colsTextArr: any[];
  
  
      colsTextArr = ['Totale', '€. ' + this.ordineItem.totale.toFixed(2)];
      var colsAlign = [0, 2];
  
  
      await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
  
  
      await sunmiInnerPrinter.setAlignment(0);// align left
  
  
      if (this.ordineItem.note != null) {
        await sunmiInnerPrinter.printTextWithFont("\nNote:" + this.ordineItem.note + '\n', 'gh', 30)
  
      }
  
  
      await sunmiInnerPrinter.printOriginalText(" \n");
  
  
      if (this.ordineItem.address != null) {
        await sunmiInnerPrinter.printTextWithFont("Indirizzo consegna:\n", 'gh', 35)
  
  
  
        var indirizzo = this.ordineItem.address.street + "," + this.ordineItem.address.civicNumber + "," + this.ordineItem.address.name + ",";
  
  
        if (this.ordineItem.address.intercom != null)
          indirizzo = indirizzo + "Interno:" + this.ordineItem.address.intercom + ",";
        if (this.ordineItem.address.building != null)
          indirizzo = indirizzo + "Palazzo:" + this.ordineItem.address.building + ",";
        indirizzo = indirizzo + this.ordineItem.address.cap + " " + this.ordineItem.address.city
        await sunmiInnerPrinter.printTextWithFont(indirizzo + '\n', 'gh', 30)
  
  
  
      } else {
  
        await sunmiInnerPrinter.printTextWithFont('Ritiro al negozio\n', 'gh', 30);
  
      }
      await sunmiInnerPrinter.printOriginalText(" \n");
  
      // await sunmiInnerPrinter.printTextWithFont("Numero di telefono:\n", 'gh', 30);
  
  
      await sunmiInnerPrinter.printTextWithFont("Tel." + this.ordineItem.usercliente.username + '\n', 'gh', 35);
  
      await sunmiInnerPrinter.printOriginalText(" \n");
      await sunmiInnerPrinter.setFontSize(30);
      //alert(JSON.stringify(this.ordineItem));
      if (this.ordineItem.address != null) {
        if (this.ordineItem.stato != 3) {
          //await sunmiInnerPrinter.printOriginalText('Consegna prev.:' + this.ordineItem.consegnaPrevisto);
          //  alert( this.ordineItem.consegnaPrevisto);
          if (this.ordineItem.consegnaPrevisto != null) {
            await sunmiInnerPrinter.setFontSize(30)
            var colsWidthArr = [17, 8];
            this.ordineItem.consegnaPrevisto = this.ordineItem.consegnaPrevisto.substring(0, this.ordineItem.consegnaPrevisto.length - 3);
            var colsTextArr = ["Consegna prevista", this.ordineItem.consegnaPrevisto];
            var colsAlign = [0, 2];
  
            await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
          }
        }
        else {
          await sunmiInnerPrinter.setAlignment(1);
          await sunmiInnerPrinter.printOriginalText('Ordine annullato');
        }
  
      } else {
        if (this.ordineItem.stato != 3) {
          // await sunmiInnerPrinter.printOriginalText('Ritiro prev.:' + this.ordineItem.consegnaPrevisto);
          // alert( this.ordineItem.consegnaPrevisto);
          if (this.ordineItem.consegnaPrevisto != null) {
  
            await sunmiInnerPrinter.setFontSize(30)
            var colsWidthArr = [17, 8];
            this.ordineItem.consegnaPrevisto = this.ordineItem.consegnaPrevisto.substring(0, this.ordineItem.consegnaPrevisto.length - 3);
            var colsTextArr = ["Ritiro previsto", this.ordineItem.consegnaPrevisto];
            var colsAlign = [0, 2];
  
            await sunmiInnerPrinter.printColumnsText(colsTextArr, colsWidthArr, colsAlign);
          }
        }
        else {
          await sunmiInnerPrinter.setAlignment(1);
  
          await sunmiInnerPrinter.printOriginalText('Ordine annullato');
  
        }
  
      }
  
      await sunmiInnerPrinter.printOriginalText("\n");
      await sunmiInnerPrinter.printOriginalText(" \n");
      await sunmiInnerPrinter.printOriginalText(" \n");
  
  
   
  
    }


  

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewordinericercaPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/viewordinericerca/viewordinericerca.ts